import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'

Vue.use(VueResource)

export default {
  formatMetadataForSelect (metadata) {
    return {
      userRoles: this.formatUserRolesForSelect(metadata.user_roles),
      engines: this.formatEnginesForSelect(metadata.engines)
    }
  },
  formatEnginesForSelect (engines) {
    var enginesSelect = []
    var allowedEngines = store.state.user.permissions.search_engines

    console.log(engines)
    console.log(allowedEngines)

    Object.keys(engines).map(function (objectKey, index) {
      if (allowedEngines.includes(engines[objectKey].id)) {
        enginesSelect.push({
          id: engines[objectKey].id,
          name: engines[objectKey].name,
          device_css: engines[objectKey].device_css,
          country_css: engines[objectKey].country_css
        })
      }
    })
    return enginesSelect
  },
  formatUserRolesForSelect (userRoles) {
    var userRolesSelect = []

    Object.keys(userRoles).map(function (objectKey, index) {
      let role = {
        id: userRoles[objectKey].id,
        name: userRoles[objectKey].name
      }
      userRolesSelect.push(role)
    })
    return userRolesSelect
  }
}



// WEBPACK FOOTER //
// ./src/services/metadata.js